import React from 'react';

export const AnalyzingIcon = (props: any) => {
  return (
    <svg {...props} className="svg-icon">
      <svg id="icon-draw-upload" viewBox="0 0 21 21">
        <title>Draw or Upload</title>
        <path
          id="np_loader_72552_000000"
          d="M25.236,15.2H25.12l-2.954.007-.143,0a.883.883,0,0,0,.072,1.763h3.164a.888.888,0,0,0-.023-1.771Zm-4.28-2.744,0,0,2.124-2.119.112-.114a.889.889,0,0,0-1.269-1.237l-.081.082-2.084,2.093-.1.1a.883.883,0,0,0,1.3,1.195ZM16.069,6.1a.889.889,0,0,0-.888.831V7.05L15.191,10v.143a.884.884,0,0,0,1.764-.07v0l0-3v-.16a.889.889,0,0,0-.887-.809Zm-3.636,5.1-2.12-2.119L10.2,8.973A.889.889,0,0,0,8.96,10.241l.082.082,2.094,2.08.1.1a.883.883,0,0,0,1.2-1.3Zm-2.319,5.761a.883.883,0,0,0-.07-1.763H6.88A.888.888,0,0,0,6.9,16.975h.116l2.954-.01Zm1.068,2.752,0,0-2.122,2.12-.113.112a.889.889,0,0,0,1.269,1.238l.082-.083,2.083-2.093.1-.1a.884.884,0,0,0-1.3-1.2Zm5.765,2.32a.883.883,0,0,0-1.763.07v0l0,3v.159a.89.89,0,0,0,1.775-.022v-.117l-.01-2.95Zm6.15-.182L21,19.776l-.1-.1a.883.883,0,0,0-1.2,1.3l0,0,2.12,2.12.114.111a.889.889,0,0,0,1.24-1.267Z"
          transform="translate(-6.07 -6.102)"
          fill="#e8a600"
        />
      </svg>
    </svg>
  );
};
